import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="promo-code-toggle"
// Collapses the promo code form behind a "Have a promo code?" link.
// One-way reveal — once expanded, the trigger hides and the form stays open.
export default class extends Controller {
  static targets = ["trigger", "body"]

  expand() {
    this.element.classList.add("is-expanded")
    this.triggerTarget.classList.add("d-none")
    const input = this.bodyTarget.querySelector('input[type="text"]')
    if (input) input.focus()
  }
}
